module.exports = __webpack_public_path__ + "f0cca6f09699fa88ef7cda07924dc201.svg";